module.exports = __webpack_public_path__ + "static/media/brown_dwarf.dd042a3c.jpeg";